import type { Habitat } from "@cloudnest/cascadia-engine";

/**
 * Cascadia placeholder landmark token — board-game-client copy.
 *
 * Originally derived from the (removed) board-game-playground for visual parity. UI is NOT shared (CLAUDE.md).
 * Colored hex ring with a single-letter habitat tag (F / M / P / R / W).
 */
export interface PlaceholderLandmarkProps {
  readonly x: number;
  readonly y: number;
  readonly radius: number;
  readonly habitat: Habitat;
  readonly cardId: string;
  readonly testId?: string;
}

const HABITAT_STROKE: Record<Habitat, string> = {
  forest: "var(--cn-cascadia-hab-forest)",
  mountain: "var(--cn-cascadia-hab-mountain)",
  prairie: "var(--cn-cascadia-hab-prairie)",
  river: "var(--cn-cascadia-hab-river)",
  wetland: "var(--cn-cascadia-hab-wetland)",
};

const HABITAT_LETTER: Record<Habitat, string> = {
  forest: "F",
  mountain: "M",
  prairie: "P",
  river: "R",
  wetland: "W",
};

export function PlaceholderLandmark({
  x,
  y,
  radius,
  habitat,
  cardId,
  testId,
}: PlaceholderLandmarkProps) {
  return (
    <g
      data-testid={testId ?? `placeholder-landmark-${cardId}`}
      data-habitat={habitat}
      data-card-id={cardId}
    >
      <circle
        cx={x}
        cy={y}
        r={radius}
        fill="none"
        stroke={HABITAT_STROKE[habitat]}
        strokeWidth={radius * 0.22}
      />
      <circle
        cx={x}
        cy={y}
        r={radius * 0.72}
        fill="var(--cn-cascadia-landmark-bronze)"
        stroke="var(--cn-cascadia-tile-outline)"
        strokeWidth={0.5}
      />
      <text
        x={x}
        y={y + radius * 0.32}
        textAnchor="middle"
        fontSize={radius * 0.95}
        fontWeight={700}
        fill="var(--cn-cascadia-bg)"
        style={{ pointerEvents: "none", userSelect: "none" }}
      >
        {HABITAT_LETTER[habitat]}
      </text>
    </g>
  );
}
